// extracted by mini-css-extract-plugin
export default {"titleContainer":"_1pT9pio_aaXVifTCml0NCO"};